import * as React from 'react'
import { useHistory } from 'react-router-dom'
import { Alert, Button, Col, Form, Image, Row } from 'react-bootstrap'
import {  AxiosInstance, uploadFileServer } from '../../utils/RequestMethods'

import config from '../../constants/config'
import images from '../../constants/images'

import ButtonLoading from '../../components/ButtonLoading/ButtonLoading'
import ButtonUploadImage from '../../components/ButtonUploadImage'
import InputPhone from '../../components/InputPhone'
import { WorkerT } from '../../types/Worker'
import { randomId } from '../../utils'
import GoogleMapAutoComplete from '../../components/MapBoxAutoComplete/GoogleMapAutoComplete'

interface NewWorkerProps {

}

export interface Worker {
    address: string,
    address2: string,
    email: string,
    firstName: string,
    lastName: string,
    phone: string,
    profilePic: string
}

export const WorkerObj: Worker = {
    address: '',
    address2: '',
    email: '',
    firstName: '',
    lastName: '',
    phone: '',
    profilePic: ''
}

const NewWorker: React.FunctionComponent<NewWorkerProps> = ({ }) => {
    let [addBtnDisabled, setAddBtnDisabled] = React.useState(false)
    let [showError, setShowError] = React.useState(false)
    let [showSuccess, setShowSuccess] = React.useState(false)
    let [worker, setWorker] = React.useState(Object.assign({}, WorkerObj))
    const [fileLogo, setFileLogo] = React.useState(null)
    const history = useHistory()
    const addAnother = (): void => {
        setWorker(Object.assign({}, WorkerObj))
        setAddBtnDisabled(false)
        setShowSuccess(false)
    }

    const changeTextInput = (key: string, value: any): void => {
        setShowError(false)
        let w = { ...worker }
        w[key] = value
        setWorker(w)
    }

    const openFileDialogue = (): void => {
        setShowError(false)
        document.getElementById("profile_pic_input").click()
    }

    /**
     *
     * @param worker
     */
    const openWorker = (workerId: number): void => {

        history.push({
            pathname: `/worker/${workerId}`,
            search: '?new-worker=true',
        })
    }

    const generateRandomEmail = () => {
        let email = randomId();
        email = `${email}@movesheet.com`
    }

    /**
     *
     * @returns
     */
    const saveWorker = async (): Promise<string> => {
        setAddBtnDisabled(true)
        setShowError(false)
        if (worker.firstName == "" || worker.lastName == "") {
            throw new Error("First and last name required.");
        }
        let params = { ...worker }
        try {
            let res = await AxiosInstance.post(`${config.url.workers}`, params)
            if (res && res.data) {

                setShowSuccess(true)

                setTimeout(() => {
                    // @ts-ignore
                    openWorker(res.data.id)
                }, 1000);
                let message = `${worker.firstName} ${worker.lastName} has been added.`
                return message
            }
            throw new Error("add worker fail")
        } catch (error) {
            setShowError(true)
            setAddBtnDisabled(false)
            throw error;
        }

    }


    /**
     *
     */
    const clearFields = () => {
        setWorker(Object.assign({}, WorkerObj))
    }

    /**
     *
     * @param event
     */
    const updateProfilePic = (event: any): void => {
        let reader = new FileReader()
        let file = event.target.files[0]
        reader.onload = () => {
            file.uri = reader.result
            let w = { ...worker }
            w.profilePic = file.uri
            setWorker(w)
        }
        reader.readAsDataURL(file)
    }

    /**
     *
     * @param key
     * @param file
     * @returns
     */
    const uploadProfilePicture = async (key: string, file: any): Promise<string> => {
        try {
            const res = await uploadFileServer(file)
            if (res.source_url) {
                //updateDirty('profilePic', res.source_url)
                let params = {
                    logo: res.source_url
                }
                params[key] = res.source_url
                return res.source_url
            }
        } catch (error) {
            throw new Error(error)
        }
    }

    return (
        <>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 3fr' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr', textAlign: 'center', width: 200 }}>
                    <Image
                        style={{ width: 200, height: 200 }}
                        src={fileLogo && fileLogo.uri ? fileLogo.uri : worker.profilePic ? worker.profilePic : images.noProfilePic} />
                    {/* <Image
                        src={worker.profilePic == '' ? images.noProfilePic : worker.profilePic}
                        style={{ width: 200, height: 200 }} />
                    {!addBtnDisabled && <a
                        href="#"
                        onClick={openFileDialogue}>
                        Edit Profile Image
                    </a>}
                    <input
                        id="profile_pic_input"
                        onChange={updateProfilePic}
                        style={{ display: "none" }}
                        type="file" />
                    <div> */}
                    <ButtonUploadImage
                        type="button"
                        //default={false}
                        accept={"image/png, image/jpeg"}
                        className="btn-link  mt-2"
                        onChangeFile={async (file) => {
                            setFileLogo(file)


                        }}> Edit Profile Image</ButtonUploadImage>
                    {fileLogo && <div>
                        <Button variant="light" onClick={() => { setFileLogo(null) }}> Cancel</Button>
                        <ButtonLoading
                            className="btn-primary"
                            onClickFetching={async (e): Promise<string> => {
                                try {
                                    let res = await uploadProfilePicture("logo", fileLogo)
                                    if (res) {
                                        let w = { ...worker }
                                        w.profilePic = res
                                        setWorker(w)
                                        setTimeout(() => {
                                            setFileLogo(null)
                                        }, 1000);
                                        return "Profile Pic saved."
                                    }
                                } catch (error) {
                                    throw new Error(error)
                                }

                            }}>
                            Save</ButtonLoading>
                    </div>}
                </div>

                <Form className="mt-2">

                    <Row>
                        <Form.Group as={Col} controlId="firstname">
                            <Form.Control
                                className='input-material'
                                onChange={(event: any) => { changeTextInput('firstName', event.target.value) }}
                                placeholder='First Name'
                                style={{ fontSize: 33 }}
                                required
                                value={worker.firstName} />
                        </Form.Group>
                        <Form.Group as={Col} controlId="lastname">
                            <Form.Control
                                className='input-material'
                                onChange={(event: any) => { changeTextInput('lastName', event.target.value) }}
                                placeholder='Last Name'
                                style={{ fontSize: 33 }}
                                required
                                value={worker.lastName} />
                        </Form.Group>
                    </Row>
                    <Row>
                        <Form.Group as={Col} controlId="phone">
                            <InputPhone
                                numberFormat={true}
                                placeholder='Phone'
                                className="input-material"
                                defaultValue={`${worker.phone}`}
                                value={`${worker.phone}`}

                                onChangePhone={val => {
                                    changeTextInput('phone', val)
                                }}
                                onChangeValue={val => {
                                    // console.log("val", val)
                                    // changeTextInput('phone', val)
                                }} />

                        </Form.Group>
                        <Form.Group as={Col} controlId="email">
                            <Form.Control
                                className='input-material'
                                onChange={(event: any) => { changeTextInput('email', event.target.value) }}
                                placeholder='Email'
                                value={worker.email} />
                        </Form.Group>
                    </Row>
                    <Row>
                        <Form.Group as={Col} controlId="address">
                            <GoogleMapAutoComplete
                                idAddresss="address_From"
                                className='input-material'
                                apiKey={config.keyMap}
                                onChangeText={text => { }}
                                onPress={async location => {
                                    let w = { ...worker }
                                    w.address = location.verbose_address
                                    setWorker(w)
                                    // onChangeInputs("addressFrom", location.verbose_address)
                                    // updateDirty("addressFrom", location.verbose_address)
                                }}

                                placeholder='Address'
                                textValue={`${worker.address}`}
                            />


                        </Form.Group>
                        <Form.Group as={Col} controlId="address2">

                            <Form.Control
                                className='input-material'
                                onChange={(event: any) => { changeTextInput('address2', event.target.value) }}
                                placeholder='Unit'
                                value={worker.address2} />
                        </Form.Group>
                    </Row>

                    <ButtonLoading
                        style={{ marginLeft: 0 }}
                        onClickFetching={saveWorker}
                        className="btn-success mt-5"> Add Worker</ButtonLoading>


                </Form>
            </div>
        </>
    )
}

export default NewWorker
